import { MediaLightbox, ReelViewer } from '@/components/media';
import { type DeliveryViewers } from '@/hooks/useDeliveryViewers';

type Props = { viewers: DeliveryViewers };

/**
 * Mounts both viewers for whichever tiles are on screen.
 *
 * A component and not part of the hook because a hook cannot render, and a
 * separate one rather than lines repeated at each call site because there are
 * eight of those — the gallery and the proof strip on seven other pages — and
 * eight copies of the same two elements is eight chances for one of them to
 * open the wrong stack.
 *
 * Both are rendered unconditionally and closed. A `Dialog` that is not open
 * renders nothing at all, so this costs two function calls; conditioning the
 * elements themselves would unmount the open one mid-transition.
 */
export function DeliveryMediaViewers({ viewers }: Props) {
  return (
    <>
      <MediaLightbox
        open={viewers.imagesOpen}
        images={viewers.images}
        index={viewers.imageIndex}
        onIndexChange={viewers.setImageIndex}
        onClose={viewers.close}
        label="Delivery photographs"
      />
      <ReelViewer
        open={viewers.videosOpen}
        videos={viewers.videos}
        index={viewers.videoIndex}
        onIndexChange={viewers.setVideoIndex}
        onClose={viewers.close}
      />
    </>
  );
}
